import { m } from "framer-motion";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import ProgressBar from "components/progress-bar";
import Logo from "../logo";
import { BorderLinearProgress } from "./style";

const StyledRoot = styled("div")(({ theme }) => ({
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  zIndex: 9998,
  width: "100%",
  height: "100%",
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
}));

export default function FullPageLoader() {
  return (
    <>
      <ProgressBar />
      <StyledRoot>
        <>
          <m.div
            animate={{
              scale: [1, 0.9, 0.9, 1, 1],
              opacity: [1, 0.48, 0.48, 1, 1],
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              repeatDelay: 1,
              repeat: Infinity,
            }}
            style={{ top: "30%", left: "40%", position: "absolute" }}
          >
            <Logo disabledLink sx={{ width: 64, height: 64, top: 100 }} />
          </m.div>
          <Box sx={{ width: "70%" }}>
            <BorderLinearProgress />
          </Box>
        </>
      </StyledRoot>
    </>
  );
}
